import { render, staticRenderFns } from "./CareCenter.vue?vue&type=template&id=219c8592&"
import script from "./CareCenter.vue?vue&type=script&lang=js&"
export * from "./CareCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports